import script from "./content-pods.vue?vue&type=script&lang=js"
export * from "./content-pods.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__